/**
 * App Component
 *
 * React Router統合
 */

import { RouterProvider } from "react-router/dom";
import { router } from "./router";
import { useEffect, useState } from "react";
import { Splash } from "./components/shared/Splash";

export default function App() {
  // 初期値（初回ロード開始時は false のことが多い）
  const [initialized, setInitialized] = useState(
    (router as { state?: { initialized?: boolean } }).state?.initialized ?? false,
  );

  useEffect(() => {
    const unsubscribe = (router as { subscribe?: (callback: (state: { initialized?: boolean }) => void) => (() => void) | undefined }).subscribe?.((state: { initialized?: boolean }) => {
      setInitialized(Boolean(state?.initialized));
    });
    return () => unsubscribe?.();
  }, []);

  return (
    <>
      {!initialized && <Splash />}
      <RouterProvider router={router} />
    </>
  );
}
